module.exports = __webpack_public_path__ + "img/icon_play-btn.fffe4559.svg";